import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { brandAssets } from "../../data/site";
import { ActionLink } from "../ActionLink";
import { ParallaxImage } from "../ParallaxImage";
import { Reveal } from "../Reveal";
type HeroSectionProps = {
  assessmentUrl: string;
};
const credentials = ["Bilingual movement coach", "Professional dancer", "Choreographer", "Fitness professional", "Denver based", "Online worldwide"];
export function HeroSection({
  assessmentUrl
}: HeroSectionProps) {
  const reduceMotion = useReducedMotion();
  const reveal = reduceMotion ? {} : {
    initial: {
      opacity: 0,
      y: 20
    },
    animate: {
      opacity: 1,
      y: 0
    }
  };
  return <>
      <section id="top" className="relative min-h-screen overflow-hidden bg-cream pt-20 text-ink" data-id="element-157" data-mp="bbyoc8yxeqxp">
        <div className="mx-auto grid min-h-[calc(100vh-5rem)] max-w-[1600px] lg:grid-cols-[1.35fr_0.65fr]" data-id="element-158" data-mp="21oe9j6a4avmj">
          <div className="flex flex-col justify-center px-5 py-20 sm:px-8 lg:px-12 xl:px-20" data-id="element-159" data-mp="25pprqqqnwekp">
            <motion.p {...reveal} transition={{
            duration: 0.24,
            ease: [0.22, 1, 0.36, 1]
          }} className="text-[10px] font-bold uppercase tracking-[0.24em] text-bronze" data-id="element-160" data-mp="2adz3soz5i023">Leo Tovar Method · Holistic performance coaching</motion.p>
            <motion.h1 {...reveal} transition={{
            duration: 0.28,
            delay: 0.05,
            ease: [0.22, 1, 0.36, 1]
          }} className="mt-8 max-w-6xl font-display text-[clamp(3.8rem,8.2vw,8.8rem)] font-semibold uppercase leading-[0.82] tracking-[-0.055em]" data-id="element-161" data-mp="2k4bpikipbz9t"><motion.span className="block" {...reduceMotion ? {} : {
              initial: {
                opacity: 0,
                y: 18
              },
              animate: {
                opacity: 1,
                y: 0
              }
            }} transition={{
              duration: 0.28,
              delay: 0.06
            }} data-id="element-162" data-mp="1rfwj2mdmypa3">Move better.</motion.span><motion.span className="block" {...reduceMotion ? {} : {
              initial: {
                opacity: 0,
                y: 18
              },
              animate: {
                opacity: 1,
                y: 0
              }
            }} transition={{
              duration: 0.28,
              delay: 0.1
            }} data-id="element-163" data-mp="21f5bhasurvuc">Feel stronger.</motion.span><motion.span className="block text-bronze" {...reduceMotion ? {} : {
              initial: {
                opacity: 0,
                y: 18
              },
              animate: {
                opacity: 1,
                y: 0
              }
            }} transition={{
              duration: 0.28,
              delay: 0.14
            }} data-id="element-164" data-mp="3crefupd853oz">Live with purpose.</motion.span></motion.h1>
            <motion.div {...reveal} transition={{
            duration: 0.28,
            delay: 0.16,
            ease: [0.22, 1, 0.36, 1]
          }} className="mt-9 max-w-2xl border-l border-bronze pl-6" data-id="element-165" data-mp="3ez710ruib806"><p className="text-base leading-8 text-ink/72 sm:text-lg" data-id="element-166" data-mp="3ow229ii5zmi5">Personalized coaching built around how you move, what you’re experiencing, and what you want to achieve.</p></motion.div>
            <motion.div {...reveal} transition={{
            duration: 0.28,
            delay: 0.2,
            ease: [0.22, 1, 0.36, 1]
          }} className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-167" data-mp="2w74jzfdydppe"><ActionLink href={assessmentUrl} className="w-full sm:w-auto" data-id="element-168" data-mp="313bqb9a9h37v">Start your assessment</ActionLink><ActionLink href="#method" variant="outline" className="w-full sm:w-auto" data-id="element-169" data-mp="3637vvcylx2pj">Discover the method</ActionLink></motion.div>
            <p className="mt-10 text-[10px] font-bold uppercase leading-6 tracking-[0.16em] text-ink/45" data-id="element-170" data-mp="2dfvav783h2yc">Online coaching worldwide <span className="px-2 text-bronze" data-id="element-171" data-mp="2ieesivfnnskw">•</span> 1:1 coaching in Denver <span className="px-2 text-bronze" data-id="element-172" data-mp="2iclo7msilkg2">•</span> English / Español</p>
          </div>
          <aside className="relative flex min-h-[540px] flex-col justify-end overflow-hidden border-t border-ink/10 p-5 sm:min-h-[680px] sm:p-8 lg:min-h-0 lg:border-l lg:border-t-0 lg:p-12" aria-label="Leo Tovar professional background" data-id="element-173" data-mp="zhprk8415yag">
            <ParallaxImage src={brandAssets.hero} alt="Leo Tovar, movement and performance coach" className="object-center" loading="eager" data-id="element-174" data-mp="lkkgtutdgb8v" />
            <div className="absolute inset-x-0 bottom-0 h-[42%] bg-ink/80 lg:h-[46%]" aria-hidden="true" data-id="element-175" data-mp="gm95tgrcbup2" />
            <div className="relative border-t border-sand pt-5 text-cream lg:pt-7" data-id="element-176" data-mp="bsy57xd4ga5l"><p className="text-[10px] font-bold uppercase tracking-[0.2em] text-sand" data-id="element-177" data-mp="7tpbutlzueak">Movement-led experience</p><ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 lg:mt-5 lg:block lg:space-y-3" data-id="element-178" data-mp="2uumf8titrhh">{credentials.map(item => <li key={item} className="font-display text-lg font-semibold uppercase tracking-[-0.02em] sm:text-xl lg:text-2xl" data-id="element-179" data-mp="3tzckbzn4mq5k">{item}</li>)}</ul></div>
          </aside>
        </div>
      </section>
      <section className="bg-ink px-5 py-28 text-cream sm:px-8 sm:py-40 lg:px-12 lg:py-48" aria-labelledby="belief-title" data-id="element-180" data-mp="1syxvah2h4rwm"><Reveal className="mx-auto max-w-[1400px] text-center" data-id="element-181" data-mp="1xvy2ivb280pb"><p className="text-[10px] font-bold uppercase tracking-[0.24em] text-sand" data-id="element-182" data-mp="1j8cxuwyjdtfa">The first step</p><h2 id="belief-title" className="mx-auto mt-8 max-w-6xl font-display text-6xl font-semibold uppercase leading-[0.85] tracking-[-0.05em] sm:text-8xl lg:text-[9rem]" data-id="element-183" data-mp="1o6eivnfiw2te">Understand how you move.</h2><p className="mx-auto mt-10 max-w-2xl text-base leading-8 text-cream/65 sm:text-lg" data-id="element-184" data-mp="1f5yjoq5tbhuc">Movement gives us more information. The assessment turns that information into a clear next step.</p></Reveal></section>
    </>;
}